// // /**
// //  ** Component template
// //  ** Use a similar setup when you define new components.
// //  */

import { h, render } from 'preact'
import { lazy, Suspense } from 'preact/compat'

import { elementReady } from '@utils/elements'
import FadeIn from '@components/fadeIn/FadeIn'
import Loader from '@components/loader/Loader'

const Footer = lazy(() => import(/* webpackChunkName: "footer.chunk" */ './components/Footer'))

const fades = {
	fadeIn: 'fade-in',
	fadeInBottom: 'fade-in-bottom',
}

elementReady('slot[name=footer]').then(footer => {
	render(
		<Suspense
			fallback={
				<Loader
					heights={{
						desktop: '678px',
						tablet: '867px',
						mobile: '1197px',
					}}
				/>
			}
		>
			<FadeIn fade={fades.fadeIn}>
				<Footer />
			</FadeIn>
		</Suspense>,
		footer,
	)
})
